<template>
  <div class="MAIN">
    <div id="map" :style="mapstyle">
      <headerVisualization @windowresize="windowresize"></headerVisualization>
      <div id="title">
        <img :src="police" alt="" class="icon" />
        <span>报警 : {{ eventsnum }}</span>
        <img :src="Warning" alt="" class="icon" />
        <span>预警 : {{ ordernum }}</span>
      </div>
      <div id="flex">
        <Networkmanagementoperation></Networkmanagementoperation>
        <Secondarywatersupply></Secondarywatersupply>
      </div>
    </div>
    <div id="popup" class="ol-popup">
      <a href="#" id="popup-closer" class="ol-popup-closer"></a>
      <div id="popup-content"></div>
    </div>
    <div></div>
    <a-modal :title="Title" :visible="visible" :footer="null" :bodyStyle="bodyStyle" @cancel="handleCancel">
      <p>设备名称 : {{ modelInfo.flowMeterName }}</p>
      <p>报警(预警)内容 : {{ modelInfo.alarmContent }}</p>
      <p>报警(预警)次数 : {{ modelInfo.num }}</p>
      <p>报警(预警)时间 : {{ modelInfo.createTime }}</p>
    </a-modal>
  </div>
</template>

<script>

import 'ol/ol.css'
import headerVisualization from './modules/warning-headerVisualization'
import Networkmanagementoperation from './modules/Network-management-operation.vue'
import Secondarywatersupply from './modules/Secondary-water-supply.vue'
import Map from 'ol/Map'
import Overlay from 'ol/Overlay'
import TileLayer from 'ol/layer/Tile'
import View from 'ol/View'
import XYZ from 'ol/source/XYZ'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Feature from 'ol/Feature'
import Stroke from 'ol/style/Stroke'
import Fill from 'ol/style/Fill'
import Point from 'ol/geom/Point'
import Style from 'ol/style/Style'
import Icon from 'ol/style/Icon'
import Scanler from 'ol/control/ScaleLine'
import { defaults as defaultControls } from 'ol/control'
import * as olProj from 'ol/proj'

export default {
  name: 'EarlyWarningAlarmLargeScreen',
  components: {
    headerVisualization,
    Networkmanagementoperation,
    Secondarywatersupply
  },
  data () {
    return {
      map: null,
      infoWindow: null,
      mapcenter: [],
      mapstyle: {
        width: '100%',
        height: window.innerHeight - 10 + 'px',
        'overflow-x': 'hidden'
      },
      bodyStyle: {
        background: 'rgba(0, 0, 0, 0)'
      },
      tabledata: [],
      modelInfo: {},
      Warning: '/warng.gif',
      police: '/police.gif',
      policeicon: '/police.gif',
      orderlist: [],
      eventslist: [],
      ordernum: 0,
      eventsnum: 0,
      warterrednum: 0,
      warterorangnum: 0,
      waterrednum: 0,
      waterorangenum: 0,
      Secondarynum: 0,
      Secondarywarngnum: 0,
      Secondaryrednum: 0,
      Secondaryorangenum: 0,
      currentInfo: {},
      watersourceinfo: {},
      watersourcewarnginfo: {},
      networkInfo: {},
      networkWarngInfo: {},
      SecondaryInfo: {},
      SecondaryWarngInfo: {},
      visible: false,
      visiblelist: false,
      Title: '',
      index: 0,
      redindex: 0,
      watersourceindex: 0,
      watersourceredindex: 0,
      Secondaryindex: 0,
      Secondaryorangeindex: 0,
      WaterworksList: [],
      networkList: [],
      SecondaryList: [],
      container: null,
      content: null,
      closer: null,
      overlay: null,
      intervalName: '',
      orangeList: [],
      redList: [],
      networkRedList: [],
      networkOrangeList: [],
      SecondaryredList: [],
      SecondaryorangeList: [],
      columns: [
        {
          title: '设备名称',
          dataIndex: 'flowMeterName'
        },
        {
          title: '报警(预警)内容',
          dataIndex: 'alarmContent'
        },
        {
          title: '报警(预警)次数',
          dataIndex: 'num'
        },
        {
          title: '报警时间',
          dataIndex: 'createTime'
        }
      ]
    }
  },
  computed: {
    title () {
      return `${this.$store.getters.userInfo.tenant.shortName}智慧管理平台`
    },
    currentUser () {
      return this.$store.getters.userInfo
    },
    token () {
      return this.$store.getters.token
    }
  },
  created () {
    this.setSystemName()
  },
  mounted () {
    this.initMap()
    this.getpolice()
  },
  destroyed () {
    clearInterval(this.intervalName)
  },
  methods: {
    setSystemName () {
      this.$store.commit('SET_SYSTEMNAME', `${this.$store.getters.userInfo.realName}预警报警系统`)
    },
    initMap () {
      const gcj02Extent = [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244]
      const gcjMecator = new olProj.Projection({
        code: 'GCJ-02',
        extent: gcj02Extent,
        units: 'm'
      })
      olProj.addProjection(gcjMecator)
      olProj.addCoordinateTransforms('EPSG:4326', gcjMecator, window.projzh.ll2gmerc, window.projzh.gmerc2ll)
      olProj.addCoordinateTransforms('EPSG:3857', gcjMecator, window.projzh.smerc2gmerc, window.projzh.gmerc2smerc)
      // var projection = getProjection('EPSG:4326')
      this.mapcenter = this.currentUser.tenant.point
      const roadLayer = new TileLayer({
        title: '高德地图',
        source: new XYZ({
          projection: gcjMecator,
          // url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}',
          url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?x={x}&y={y}&z={z}&lang=zh_cn&size=1&scl=1&style=8'
        })
      })
      this.map = new Map({
        view: new View({
          center: this.mapcenter, // 中心点, 填的是经纬度
          projection: 'EPSG:4326', // EPSG:4326格式的经纬度
          zoom: 15, // 地图默认缩放级别
          maxZoom: 19, // 地图最大缩放级别
          minZoom: 1 // 地图最小缩放级别
        }),
        target: 'map', // 地图容器id
        layers: [roadLayer],
        controls: defaultControls({
          zoom: false,
          rotate: false,
          attribution: false
        })
      })
      const scanler = new Scanler()
      this.map.addControl(scanler)
      this.addPopup()
      console.log(JSON.stringify(this.mapcenter))
    },
    addPopup () {
      this.container = document.getElementById('popup')
      this.content = document.getElementById('popup-content')
      this.closer = document.getElementById('popup-closer')
      this.overlay = new Overlay({
        element: this.container,
        autoPan: {
          animation: {
            duration: 250
          }
        }
      })
      this.map.addOverlay(this.overlay)
      this.closer.onclick = () => {
        this.overlay.setPosition(undefined)
        this.closer.blur()
        return false
      }
      this.map.on('click', (e) => {
        console.log('click=====Early-warning-alarm-large-screen')
        this.map.forEachFeatureAtPixel(e.pixel, (feature) => {
          this.pointType = feature.get('remark')
          const coordinate = e.coordinate
          let url
          switch (feature.get('remark')) {
            case 'events':
              url = `/pipe-network/remote_water_meter_alarm_messages/${feature.get('name')}`
              this.$http.get(url).then((resolve) => {
                this.currentInfo = resolve.data
                console.log(JSON.stringify(this.currentInfo))
                const info = `<p>设备名称 : ${this.currentInfo.flowMeterName}</p><p>报警(预警)内容 : ${this.currentInfo.alarmContent}</p><p>报警(预警)次数 : ${this.currentInfo.num}</p><p>报警(预警)时间 : ${this.currentInfo.createTime}</p>`
                this.content.innerHTML = info
                this.overlay.setPosition(coordinate)
              })
              break
            case 'order':
              url = `/pipe-network/remote_water_meter_alarm_messages/${feature.get('name')}`
              this.$http.get(url).then((resolve) => {
                this.currentInfo = resolve.data
                console.log(JSON.stringify(this.currentInfo))
                const info = `<p>设备名称 : ${this.currentInfo.flowMeterName}</p><p>报警(预警)内容 : ${this.currentInfo.alarmContent}</p><p>报警(预警)次数 : ${this.currentInfo.num}</p><p>报警(预警)时间 : ${this.currentInfo.createTime}</p>`
                this.content.innerHTML = info
                this.overlay.setPosition(coordinate)
              })
              break
          }
        })
      })
    },
    showmodel (item) {
      console.log(item)
      this.Title = item.flowMeterName
      if (item.geoJson == null) {
        this.modelInfo = item
        this.visible = true
      } else {
        this.currentInfo = item
        console.log(JSON.stringify(this.currentInfo))
        const info = `<p>设备名称 : ${this.currentInfo.flowMeterName}</p><p>报警(预警)内容 : ${this.currentInfo.alarmContent}</p><p>报警(预警)次数 : ${this.currentInfo.num}</p><p>报警(预警)时间 : ${this.currentInfo.createTime}</p>`
        this.content.innerHTML = info
        const coordinate = JSON.parse(item.geoJson).coordinates
        this.overlay.setPosition([coordinate[0], coordinate[1]])
        this.map.getView().setCenter([coordinate[0], coordinate[1]])
      }
    },
    showmore (type) {
      this.$router.push({ path: '/alarm-list' })
    },
    handleCancel () {
      this.visible = false
      this.modelInfo = {}
    },
    handleCancellist () {
      this.visiblelist = false
      this.modelInfo = {}
    },
    getpolice () {
      const url = '/pipe-network/remote_water_meter_alarm_messages/list/screen'
      const data = { sysTabs: '0,1,2,5', isDispose: 0 }
      const coordinatelist = []
      const orangecoordinatelist = []
      this.$http.get(url).then(({ data }) => {
        this.ordernum = data.earlyCount
        this.eventsnum = data.reportCount
        if (data.list.length > 0) {
          data.list.map((item) => {
            if (item.alarmLevel !== '预警') {
              coordinatelist.push(item)
              const coordinate = JSON.parse(item.geoJson).coordinates
              this.addSimplePoint('events', item.id, coordinate[0], coordinate[1])
            } else {
              orangecoordinatelist.push(item)

              const coordinate = JSON.parse(item.geoJson).coordinates
              this.addSimplePoint('order', item.id, coordinate[0], coordinate[1])
            }
          })
        }
      })
    },
    getwaterPolice () {
      const url = '/pipe-network/water_works_malfunctions/page'
      this.$http.get(url).then(({ data }) => {
        if (parseInt(data.total) > 0) {
          data.list.map((item) => {
            if (item.malfunctionType == 0) {
              this.networkRedList.push({
                flowMeterName: item.deviceName,
                alarmContent: item.malfunctionDescribe,
                num: item.num,
                createTime: item.createTime
              })
            } else {
              this.networkOrangeList.push({
                flowMeterName: item.deviceName,
                alarmContent: item.malfunctionDescribe,
                num: item.num,
                createTime: item.createTime
              })
            }
            this.networkList.push({
              flowMeterName: item.deviceName,
              alarmContent: item.malfunctionDescribe,
              num: item.num,
              createTime: item.createTime
            })
          })
        }
      })
    },
    addSimplePoint (type, name, x, y) {
      const point = new Point([x, y])
      const feature = new Feature({
        geometry: point,
        name: name,
        remark: type
      })
      const vectorSource = new VectorSource()
      vectorSource.addFeature(feature)
      let vectorLayer
      switch (type) {
        case 'events':
          vectorLayer = new VectorLayer({
            title: '事件',
            source: vectorSource,
            style: this.stylefunctionEvents
          })
          break
        case 'order':
          vectorLayer = new VectorLayer({
            title: '工单',
            source: vectorSource,
            style: this.stylefunctionOrder
          })
          break
      }
      this.map.addLayer(vectorLayer)
    },
    showPopup (marker, type) {
      marker.on('click', () => {
        const id = marker.getTitle()
        let url
        switch (type) {
          case 'events':
            url = `/pipe-network/remote_water_meter_alarm_messages/${id}`
            this.$http.get(url).then((resolve) => {
              this.currentInfo = resolve.data
              console.log(JSON.stringify(this.currentInfo))
              const info = `<p>设备名称 : ${this.currentInfo.flowMeterName}</p><p>报警(预警)内容 : ${this.currentInfo.alarmContent}</p><p>报警(预警)次数 : ${this.currentInfo.num}</p><p>报警(预警)时间 : ${this.currentInfo.createTime}</p>`
              this.addinfowindow(this.currentInfo.id, info, marker.getPosition())
            })
            break
          case 'order':
            url = `/pipe-network/remote_water_meter_alarm_messages/${id}`
            this.$http.get(url).then((resolve) => {
              this.currentInfo = resolve.data
              console.log(JSON.stringify(this.currentInfo))
              const info = `<p>设备名称 : ${this.currentInfo.flowMeterName}</p><p>报警(预警)内容 : ${this.currentInfo.alarmContent}</p><p>报警(预警)次数 : ${this.currentInfo.num}</p><p>报警(预警)时间 : ${this.currentInfo.createTime}</p>`
              this.addinfowindow(this.currentInfo.id, info, marker.getPosition())
            })
            break
        }
      })
    },
    addinfowindow (title, info, center) {
      this.infoWindow = new AMap.InfoWindow({
        isCustom: true, // 使用自定义窗体
        content: this.createInfoWindow(title, info)
      })
      // 在地图上打开信息窗体
      this.infoWindow.open(this.map, center)
    },
    createInfoWindow (title, content) {
      var info = document.createElement('div')
      var img = document.createElement('img')
      img.src = '/close.png'
      info.className = 'custom-info'
      info.appendChild(img)
      img.onclick = this.closeInfoWindow
      // 定义中部内容
      var middle = document.createElement('div')
      middle.className = 'info-middle'
      middle.innerHTML = content
      info.appendChild(middle)
      return info
    },
    closeInfoWindow () {
      this.map.clearInfoWindow()
    },
    stylefunctionEvents (feature) {
      return new Style({
        fill: new Fill({
          // 填充样式
          color: 'rgba(255, 255, 255,0.2)'
        }),
        stroke: new Stroke({
          // 线样式
          color: '#00c033',
          width: 2
        }),
        image: new Icon({
          src: this.Warning,
          scale: 0.8
        })
      })
    },
    stylefunctionOrder (feature) {
      // let name = feature.get("name");
      return new Style({
        fill: new Fill({
          // 填充样式
          color: 'rgba(255, 255, 255,0.2)'
        }),
        stroke: new Stroke({
          // 线样式
          color: '#00c033',
          width: 2
        }),
        image: new Icon({
          src: this.policeicon,
          scale: 0.8
        })
      })
    },
    windowresize (e) {
      this.mapstyle.height = e.height
      console.log(e)
    }
  }
}
</script>

<style lang="less" scoped>
.MAIN {
  position: relative;
  width: 100%;
  height: 100%;
  background: #000001 !important;
}

/deep/ .amap-logo {
  display: none !important;
}

#title {
  // width:100%;
  text-align: left;
  margin-left: 20px;
  z-index: 9;
  position: absolute;
  top: 70px;
  left: 20px;
  color: white;
}

#title span {
  margin-right: 20px;
  margin-left: 10px;
}

.icon {
  width: 26px;
  height: 26px;
}

.model {
  .ant-modal-content {
    position: relative;
    background-color: rgba(0, 0, 0, 0) !important;
    background-clip: padding-box;
    border: 0;
    border-radius: 2px;
    -webkit-box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    pointer-events: auto;
  }
}

#flex {
  width: 400px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: fixed;
  right: 30px;
  top: 70px;
  z-index: 9;
  background: rgba(0, 0, 0, 0);
}

.flexitem {
  width: 100%;
  height: auto;
  background: url('/iconImg/backbox-bj.png');
  background-size: 100% 100%;
  margin: 10px;
  padding: 20px;

  p {
    color: #00ebf0;
    font-size: 20px;
    font-weight: bold;
    line-height: 60px;
    margin-left: 20px;

    span {
      color: white;
      font-size: 14px;
      float: right;
      margin-right: 20px;
      padding-right: 20px;
      line-height: 70px;
    }
  }

  div {
    width: 95%;
    height: 90px;
    background: url('/box-list@2x.png');
    background-size: 100% 100%;
    margin: 0 auto;

    p {
      color: white;
      font-size: 16px;
      line-height: 35px;
      margin-left: 10px;

      span {
        font-size: 16px;
        line-height: 35px;
        position: absolute;
        right: -10px;
      }
    }

    .content {
      font-size: 14px;
      line-height: 14px;
      width: 50%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-top: -10px;
      color: #ebb637;

      span {
        line-height: 10px;
        font-size: 13px;
      }
    }

    .link {
      color: #ebb637;
      font-size: 14px;
      line-height: 10px;
      float: right;
      margin-right: 10px;
      cursor: pointer;
    }
  }
}

/deep/[data-v-5833764b] .content-window-card {
  margin-top: 15px;
  margin-left: 450px;
}

/deep/ .ant-table-pagination.ant-pagination {
  float: right;
  margin: 16px 0 30px 20px;
}

/deep/ .ant-pagination-item {
  display: inline-block;
  min-width: 32px;
  height: 32px;
  margin-right: 8px;
  font-family: Arial;
  line-height: 30px;
  text-align: center;
  vertical-align: middle;
  list-style: none;
  color: #00ebf0;
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid #00ebf0;
  border-radius: 2px;
  outline: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/deep/ .ant-pagination-prev .ant-pagination-item-link,
/deep/ .ant-pagination-next .ant-pagination-item-link {
  display: block;
  height: 100%;
  font-size: 12px;
  text-align: center;
  color: #00ebf0;
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid #00ebf0;
  border-radius: 2px;
  -webkit-box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: auto;
}

#flex {
  width: 400px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: fixed;
  right: 30px;
  top: 70px;
  z-index: 9;
  background: rgba(0, 0, 0, 0);
}

.flexitem {
  width: 100%;
  height: auto;
  background: url('/iconImg/backbox-bj.png');
  background-size: 100% 100%;
  margin: 10px;
  padding: 20px;

  p {
    color: #00ebf0;
    font-size: 20px;
    font-weight: bold;
    line-height: 60px;
    margin-left: 20px;

    span {
      color: white;
      font-size: 14px;
      float: right;
      margin-right: 20px;
      padding-right: 20px;
      line-height: 70px;
    }
  }

  div {
    width: 95%;
    height: 90px;
    background: url('/box-list@2x.png');
    background-size: 100% 100%;
    margin: 0 auto;

    p {
      color: white;
      font-size: 16px;
      line-height: 35px;
      margin-left: 10px;

      span {
        font-size: 16px;
        line-height: 35px;
        position: absolute;
        left: 359px;
      }
    }

    .contentt {
      font-size: 14px;
      line-height: 14px;
      width: 50%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-top: -10px;
      color: #ebb637;
    }

    .spans {
      line-height: 10px !important;
      font-size: 13px !important;
      float: right;
      margin-right: 63px;
      color: #fff;
      margin-top: -26px;
    }

    .wrap {
      height: 20px;
      overflow: hidden;
      position: absolute;
      top: 30;
      left: 100;
      width: 100%;
    }

    span {
      margin: 0;
      height: 30px;
      width: 100%;
    }

    .content span {
      position: absolute;
    }

    @-webkit-keyframes anim1 {
      0% {
        top: 20px;
        opacity: 1;
      }

      50% {
        top: -20px;
        opacity: 1;
      }

      75% {
        top: -20px;
        opacity: 0;
      }

      100% {
        top: 20px;
        opacity: 0;
      }
    }

    @-webkit-keyframes anim2 {
      0% {
        top: -20px;
        opacity: 0;
      }

      25% {
        top: 20px;
        opacity: 0;
      }

      50% {
        top: 20px;
        opacity: 1;
      }

      100% {
        top: -20px;
        opacity: 1;
      }
    }

    .content span:nth-child(1) {
      -webkit-animation: anim1 3s linear infinite;
    }

    .content span:nth-child(2) {
      -webkit-animation: anim2 3s linear infinite;
    }

    .link {
      color: #ebb637;
      font-size: 14px;
      line-height: 10px;
      float: right;
      margin-right: 10px;
      cursor: pointer;
      margin-top: 20px;
    }
  }
}

/deep/ .ant-table-pagination.ant-pagination {
  float: right;
  margin: 16px 0 30px 20px;
}

/deep/ .ant-pagination-item {
  display: inline-block;
  min-width: 32px;
  height: 32px;
  margin-right: 8px;
  font-family: Arial;
  line-height: 30px;
  text-align: center;
  vertical-align: middle;
  list-style: none;
  color: #00ebf0;
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid #00ebf0;
  border-radius: 2px;
  outline: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/deep/ .ant-pagination-prev .ant-pagination-item-link,
/deep/ .ant-pagination-next .ant-pagination-item-link {
  display: block;
  height: 100%;
  font-size: 12px;
  text-align: center;
  color: #00ebf0;
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid #00ebf0;
  border-radius: 2px;
  outline: none;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

/deep/ .ant-table-thead>tr:first-child>th:first-child {
  border-top-left-radius: 2px;
  color: #00ebf0;
  background: rgba(0, 0, 0, 0);
  border: 1px solid #00ebf0;
}

/deep/ .ant-table-thead>tr>th,
/deep/ .ant-table-tbody>tr>td {
  padding: 16px 16px;
  color: #00ebf0;
  background: rgba(0, 0, 0, 0);
  border: 1px solid #00ebf0;
  overflow-wrap: break-word;
}

.link {
  cursor: pointer;
}

.top {
  width: 95% !important;
  height: 90px !important;
  background: url('/box-list@2x.png') !important;
  background-size: 100% 100% !important;
  margin: 0 auto !important;
  margin-top: -25px !important;
  margin-bottom: 10px !important;

  p {
    color: white !important;
    font-size: 16px !important;
    line-height: 35px !important;
    margin-left: 10px !important;

    span {
      font-size: 16px !important;
      line-height: 35px !important;
      position: absolute;
      right: -10px;
    }
  }

  .contentt {
    font-size: 14px !important;
    line-height: 14px !important;
    width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: 10px !important;
    color: #ff3b3b !important;
  }

  .link {
    margin-top: 30px;
    margin-right: -303px;
    color: #ebb637 !important;
    font-size: 14px !important;
    line-height: 10px !important;
    float: right !important;
    margin-right: 10px !important;
    cursor: pointer;
  }
}

.minicon {
  width: 18px;
  height: 18px;
}

.ol-popup {
  position: absolute;
  width: 400px;
  height: auto;
  background: url('/popup.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 20px 40px;
  bottom: 13px;
  left: 0px;
  min-width: 280px;
  color: #00ebf0;
}

.ol-popup:after {
  border-top-color: #164a98;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}

.ol-popup:before {
  border-top-color: #00ebf0;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}

.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 10px;
  right: 8px;
  color: #00ebf0;
}

.ol-popup-closer:after {
  content: '✖';
}

/deep/.ant-modal-content {
  background: url('/box-background@2x.png');
  background-size: 100% 100%;
  color: #00ebf0;
}

/deep/ .ant-modal-header {
  background: rgba(0, 0, 0, 0);
  border: none;
  border-bottom: 1px solid #00ebf0;
  margin: 0px 25px 0px 25px;
}

/deep/ .ant-modal-title {
  color: #00ebf0;
}

/deep/ .ant-modal-close-x {
  color: #00ebf0;
  margin-right: 10px;
  margin-top: 10px;
  display: none;
}

/deep/ .custom-info {
  width: 400px;
  height: auto;
  padding-left: 10px;
  padding-bottom: 35px;
  background: url('/popup.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  position: relative;
  left: 220px;

  p {
    height: 2rem;
    padding: 15px;
    margin-left: 20px;
    color: #00ebf0;
    background: rgba(0, 0, 0, 0);
    // display:none;
  }

  img {
    width: 24px;
    height: 24px;
    float: right;
    margin-right: 10px;
    margin-top: 10px;
  }
}
</style>
